import { Component, Input } from "@angular/core";

@Component({
  selector: "page-card-item-title-description",
  template: "",
  standalone: false
})
export class PageCardItemTitleDescription {
  @Input() title!: string;
}
